import { TipoUsoIPv4 } from '@/shared/interfaces';

export const TIPO_USO_GRUPO_IPV4 = [TipoUsoIPv4.ESTATICO, TipoUsoIPv4.DINAMICO];
